export class GlobalBaseLocation {
  id: number;
  key: string;
  display: string;
}
